import * as React from "react"
import * as ReactDom from "react-dom"
import Ranking from "../components/views/Ranking";
import { requestPageData } from "../services/api";
import { checkLang, setCurrentPage } from "../services/general";

export const page = async () => {
    setCurrentPage('')

    const rankingContainer = document.getElementById('ranking')
    let RANKINGINFO;
    let response = await fetch("/ranking/data-draws",{ method: "GET",headers: {"Content-Type": "application/json"}})
    RANKINGINFO = await response.json();
    // const RANKINGINFO = await requestPageData({ content: "partner", nid: rankingContainer.dataset.nid, langcode: checkLang() })
    ReactDom.render(<Ranking  data={RANKINGINFO} />, rankingContainer)
}